import {FunctionComponent, useState} from "react";
import {IPage} from "../../components/PageWrapper/types";
import {Link, MailButton, MailButtonContainer, MailButtonWrapper, DeviceVerificationPageContainer, Phrase, SubTitle} from "./DeviceVerificationPage.style";
import I18n from "../../components/I18n/I18n";
import gmail from './images/gmail.svg';
import outlook from './images/outlook.svg';
import useIdentityParams from "../../common/hooks/Parameters/UseIdentityParams";
import {asI18nKey} from "../../common/utilities/Localization";
import usePageAccessGuard from "../../common/hooks/UsePageAccessGuard";
import SupportModal from '../../components/SupportModal/SupportModal';
import LinkParagraph from "../../components/LinkParagraph/LinkParagraph";
const EmailSentPage: FunctionComponent<IPage> = ({translate}) => {
    const { routerParams, allParams } = useIdentityParams<{
        email: string;
    }>();
    const [supportModalOpen, setSupportModalOpen] = useState<boolean>(false);

    usePageAccessGuard(!routerParams.email);

    return <DeviceVerificationPageContainer>
        <SubTitle>
            <I18n params={{ email: allParams.email }}>device_verification.email.sub_title</I18n>
        </SubTitle>
        <MailButtonContainer>
            <MailButton href={'https://gmail.com'} target="_blank">
                <MailButtonWrapper>
                    <img src={gmail} />
                    <span>Open Gmail</span>
                </MailButtonWrapper>
            </MailButton>
            <MailButton href={'https://outlook.com'} target="_blank">
                <MailButtonWrapper>
                    <img src={outlook} />
                    <span>Open Outlook</span>
                </MailButtonWrapper>
            </MailButton>
        </MailButtonContainer>
        <Phrase>
            <I18n>device_verification.email.spam_mail_text</I18n>
        </Phrase>
        <LinkParagraph
            automationName='device_verification_general_link'
            prefix={translate(asI18nKey('device_verification.general.help_text'))}
            linkLabel={translate(asI18nKey('device_verification.general.help_link_text'))}
            callback={() => setSupportModalOpen(true)}
        />
        <SupportModal
            isOpen={supportModalOpen}
            onClose={() => setSupportModalOpen(false)}
        />
    </DeviceVerificationPageContainer>
}

export default EmailSentPage;
